<template>
	<div id="app">
		<NavTop v-if="$router.currentRoute.name!=404"></NavTop>
		<router-view></router-view>
		<NavNottom v-if="$router.currentRoute.name!=404"></NavNottom>
		<!-- <div v-if="$router.currentRoute.name!=404" class="qqrelation">
			<a href="tencent://message/?uin=3518162518">
				<div class="qqtop">
					<div class="iconfont icon-qq"></div>
					<div>QQ联系</div>
				</div>
				<div class="qqbottom">
					在线联系
				</div>
			</a>
		</div> -->
	</div>
</template>

<script>
	import NavTop from '@/components/nav/navtop.vue'
	import NavNottom from '@/components/nav/navBottom.vue'
	import {mapMutations,mapState,mapActions} from 'vuex'
	export default {
		name: 'App',
		created() {
			// localStorage.setItem('qwe','!@#!@#');
			//在页面加载时读取sessionStorage里的状态信息
			    if (sessionStorage.getItem("store") ) {
			        this.$store.replaceState(Object.assign({}, this.$store.state,JSON.parse(sessionStorage.getItem("store"))))
				}
				// let token = localStorage.getItem('token');
				// if(token)  this.$store.commit('settoken',token);
			    //在页面刷新时将vuex里的信息保存到sessionStorage里
			    window.addEventListener("beforeunload",()=>{
			        sessionStorage.setItem("store",JSON.stringify(this.$store.state))
				})
				// let cokie = this.xin.getCookie('GsToken')||localStorage.getItem('GsToken');
				// if(cokie){
					
				// }else{
				// 	localStorage.removeItem("token");
				// }
		},
		mounted(){
				
		},
		computed:{
			...mapState(['isChecked'])
		},
		components: {
			NavTop,
			NavNottom
		},
		methods:{
			...mapMutations(['setclassName','setisChecked','settoken']),
			...mapActions(['setgoodsCount','getUser']),
		}
	}
</script>

<style lang="scss">
//其他
	.qqrelation{
		position: fixed;
		right: 0px;
		top: 75%;
		width: 164px;
		height: 106px;
		border: 1px solid var(--themeColor);
		cursor: pointer;
		z-index: 999;
		background: #fff;
		.qqtop{
			background: var(--themeColor);
			height: 60px;
			color: #fff;
			text-align: center;
			div{
				line-height: 60px;
				display: inline-block;
			}
			.iconfont{
				margin-right: 10px;
				font-size: 30px;
				// line-height: 30px;
			}
		}
		.qqbottom{
			font-size:20px;
			text-align: center;
			color: #005599;
			line-height: 40px;
			height: 40px;
			background:#fff;
		}
	}
	body{
		padding: 0;
		margin: 0;
	}
</style>
